export class BundleCatalogModel {
  constructor(
    public bundleCatalogId: string,
    public mediumType: string,
    public mediumTypeName: string,
    public startOrderCode: string,
    public endOrderCode: string,
    public startDelivCatalogId: string,
    public endDelivCatalogId: string,
    public bundleCatalogName: string,
    public bundleCatalogCode: string,
    public endDelivCatalogEndDate: string
  ) { }
}
